let prevHeight = window.innerHeight;
let prevWidth = window.innerWidth;

const updateAppHeight = () => {
	document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
    document.documentElement.style.setProperty('--header-height', `${document.querySelector('header').offsetHeight}px`);
    if(document.querySelector('.top-notification')) {
        document.documentElement.style.setProperty('--notification-height', `${document.querySelector('.top-notification').offsetHeight}px`);
    } else {
        document.documentElement.style.setProperty('--notification-height', `0px`);
    }
}
window.addEventListener('resize', () => {
    if (window.innerHeight !== prevHeight || window.innerWidth !== prevWidth) {
        prevHeight = window.innerHeight;
        prevWidth = window.innerWidth;
        updateAppHeight();
    }
});

updateAppHeight();

document.addEventListener('LokiRequestEnd', function () {
	updateAppHeight();
});
